import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,
  CircularProgress,
  Switch,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
  Paper,
  // ✅ ADD THESE
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,

} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import WarningIcon from "@mui/icons-material/Warning";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import { keyframes } from "@mui/system";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
function DutyDoctorDashboard() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
  const token = loginData?.token;
const [openPopup, setOpenPopup] = useState(false);
const [selectedNotificationId, setSelectedNotificationId] = useState(null);
  const [loading, setLoading] = useState(true);
 const [alertCounts, setAlertCounts] = useState({
  sosCount: 0,
  warningCount: 0,
  criticalCount: 0,
});
  const [patients, setPatients] = useState([]);

  const [availability, setAvailability] = useState(false);
  const [shiftStart, setShiftStart] = useState(null);
  const [timer, setTimer] = useState("00:00:00");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingToggle, setPendingToggle] = useState(null);
  const navigate = useNavigate();

  // ------------------ ALERTS ------------------ //

  const fetchAlerts = async () => {
    try {
      const res = await axios.get(`/api/doctorregistration/alerts/counts/${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
          setAlertCounts(res.data || {});

    } catch {
      toast.error("Failed to fetch alerts");
    }
  };

   // ------------------ PATIENTS ------------------ //
  const fetchPatients = async () => {
    try {
      const res = await axios.get(`/api/doctorregistration/alerts/details/${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPatients(res.data || []);
    } catch {
      toast.error("Failed to fetch patients");
    }
  };
const fetchAvailability = async () => {
  try {
    const res = await axios.get(
      `/api/doctorregistration/doctor/availability/${userid}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = res.data;

    setAvailability(data.availability);

    if (data.availability && data.shiftOnTime) {
      setShiftStart(data.shiftOnTime);
    } else {
      setShiftStart(null);
      setTimer("00:00:00");
    }
  } catch (err) {
    console.log(err);
  }
};
  // ------------------ TOGGLE CLICK (OPEN POPUP) ------------------ //
  const handleToggleClick = (event) => {
    setPendingToggle(event.target.checked);
    setConfirmOpen(true);
  };

  // ------------------ CONFIRM ACTION ------------------ //
  const handleConfirm = async () => {
  setConfirmOpen(false);

  try {
    await axios.post(
      "/api/doctorregistration/doctor/toggleAvailability",
      {
        userid: userid,
        availability: pendingToggle,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Reload latest status from DB
    await fetchAvailability();

    toast.success(
      pendingToggle
        ? "You are now on duty. Your shift has started."
        : "You are now offline. Your shift has ended."
    );
  } catch (err) {
    toast.error("Failed to update availability");
  }
};

  // ------------------ TIMER ------------------ //
  useEffect(() => {
    let interval;

    if (availability && shiftStart) {
      interval = setInterval(() => {
        const start = new Date(shiftStart);
        const now = new Date();
        const diff = Math.floor((now - start) / 1000);

        const hrs = String(Math.floor(diff / 3600)).padStart(2, "0");
        const mins = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");
        const secs = String(diff % 60).padStart(2, "0");

        setTimer(`${hrs}:${mins}:${secs}`);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [availability, shiftStart]);

  // ------------------ RESTORE ------------------ //
useEffect(() => {
  fetchAvailability();
}, []);

  // ------------------ INIT ------------------ //
  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await Promise.all([fetchAlerts(), fetchPatients()]);
      setLoading(false);
    };
    init();
  }, []);

  const handleAcceptAlert = async () => {
    try {
      await axios.post(
        `/api/dutydoctor/alerts/action`,
        { notificationId: selectedNotificationId ,action: "ACCEPT", },
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      toast.success("Alert Accepted");
      setOpenPopup(false);   // ✅ close popup
      fetchPatients();       // ✅ refresh list
    } catch {
      toast.error("Failed to accept alert");
    }
  };
  const handleAcceptClick = (id) => {
    setSelectedNotificationId(id);
    setOpenPopup(true);
  };
  const handleSnooze = async () => {
    try {
      await axios.post(
        `/api/dutydoctor/alerts/action`,
        { notificationId: selectedNotificationId , action: "SNOOZE",},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
  
      toast.success("Notification snoozed");
      setOpenPopup(false);
      fetchPatients(); // refresh list
    } catch {
      toast.error("Failed to snooze");
    }
  };

  const spinAnimation = keyframes`
     0% { transform: rotate(0deg); }
     100% { transform: rotate(360deg); }
   `;
   const dotPositions = [
     { top: "5%", left: "50%" },
     { top: "20%", left: "80%" },
     { top: "50%", left: "95%" },
     { top: "80%", left: "80%" },
     { top: "95%", left: "50%" },
     { top: "80%", left: "20%" },
     { top: "50%", left: "5%" },
     { top: "20%", left: "20%" },
   ];

  // ------------------ UI ------------------ //

  return (
    <DashboardLayout>
      <DashboardNavbar />
 {loading && (
              <Box
                sx={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  zIndex: 9999,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: 80, 
                    height: 80, 
                    animation: `${spinAnimation} 1.5s linear infinite`,
                  }}
                >
                  {dotPositions.map((pos, index) => (
                    <Box
                      key={index}
                      sx={{
                        width: 8, 
                        height: 8, 
                        borderRadius: "50%",
                        backgroundColor: "#1A237E", 
                        position: "absolute",
                        ...pos,
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}
      <Box p={3}>
        <Grid container spacing={3}>

          {/* 🔴 ACTIVE ALERTS */}
         <Grid item xs={12} md={4}>
  <Card
    sx={{
      borderRadius: 4,
      boxShadow: 6,
      height: "100%",
      minHeight: 220,
      display: "flex",
      flexDirection: "column",
    }}
  >
    <CardContent>

      {/* Header */}
      <Box display="flex" alignItems="center" gap={1}>
        <WarningIcon color="error" />
        <Typography variant="h6" fontWeight="bold">
          Active Alerts
        </Typography>
      </Box>

      {/* Total */}
      <Typography
        variant="h3"
        fontWeight="bold"
        mt={1}
        color="error"
      >
        {alertCounts.sosCount +
          alertCounts.warningCount +
          alertCounts.criticalCount}
      </Typography>

      {/* Breakdown */}
      <Box mt={2} display="flex" justifyContent="space-between">

        <Box textAlign="center">
          <Typography variant="caption" color="text.secondary">
            SOS
          </Typography>
          <Typography fontWeight="bold" color="error">
            {alertCounts.sosCount}
          </Typography>
        </Box>

        <Box textAlign="center">
          <Typography variant="caption" color="text.secondary">
            Warning
          </Typography>
          <Typography fontWeight="bold" color="warning.main">
            {alertCounts.warningCount}
          </Typography>
        </Box>

        <Box textAlign="center">
          <Typography variant="caption" color="text.secondary">
            Critical
          </Typography>
          <Typography fontWeight="bold" color="error.dark">
            {alertCounts.criticalCount}
          </Typography>
        </Box>

      </Box>

    </CardContent>
  </Card>
</Grid>

          {/* ⏱ ON-CALL SHIFT */}
          <Grid item xs={12} md={4}>
            <Card
    sx={{
      borderRadius: 4,
      boxShadow: 6,
      height: "100%",
      minHeight: 220,
      display: "flex",
      flexDirection: "column",
    }}
  >
              <CardContent>

                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Box display="flex" alignItems="center" gap={1}>
                    <AccessTimeIcon />
                    <Typography variant="h6" fontWeight="bold">
                      On-Call Shift
                    </Typography>
                  </Box>

                  <FormControlLabel
                    control={
                      <Switch
                        checked={availability}
                        onChange={handleToggleClick}
                        color="success"
                      />
                    }
                    label={
                      <Typography fontSize="12px">
                        {availability ? "On Duty" : "Off Duty"}
                      </Typography>
                    }
                  />
                </Box>

                {/* Date */}
                <Typography variant="caption" sx={{ opacity: 0.8, mt: 1 }}>
                  {new Date().toLocaleString("en-IN", {
                    weekday: "short",
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}
                </Typography>

                {/* Timer */}
                <Typography variant="h3" fontWeight="bold" mt={2}>
                  {timer}
                </Typography>

                {/* Status */}
                <Chip
                  label={availability ? "ACTIVE" : "OFFLINE"}
                  color={availability ? "success" : "default"}
                  size="small"
                  sx={{ mt: 2 }}
                />
              </CardContent>
            </Card>
          </Grid>

          {/* 🧑‍⚕️ PATIENTS */}
       <Grid item xs={12}>
  <Card sx={{ borderRadius: 3, boxShadow: 4 }}>
    <CardContent sx={{ p: 2 }}>

      {/* HEADER */}
 <MDBox mt={1} p={1} display="flex"  alignItems="center">
        <LocalHospitalIcon color="primary" />
      
         <MDTypography variant="h5" sx={{ flex: 1,fontSize: "1.0rem" }}>
             Patient Alerts
          </MDTypography>
      </MDBox>

      {/* TABLE */}
 <MDBox sx={{ overflowX: "auto", width: "100%" }}>
         <TableContainer component={Paper} sx={{ mt: 3, border: "1px solid #ddd", borderRadius: "8px", boxShadow: "2px 4px 10px rgba(0,0,0,0.1)" }}>
         
    <Table sx={{ tableLayout: "fixed", width: "100%", borderCollapse: "collapse" }}>

          {/* TABLE HEAD */}
          <TableHead>
            <TableRow sx={{ backgroundColor: "#1A237E" }}>
              {["Name", "Age / Gender", "Severity", "Message", "Action"].map(
               (header, index) => (
                  <TableCell
           key={index}
         sx={{
                 color: "#fff",
                fontWeight: "600", 
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "7px",
  minWidth: index === 0 ? "200px" : "100px",
width: index === 0 ? "315px" : "195px",

                whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}
            </TableRow>
       

          {/* TABLE BODY */}
          <TableBody>
            {patients.map((p) => (
              <TableRow
                key={p.notificationId}
                hover
                sx={{
                  "& td": {
                    borderBottom: "1px solid #e0e0e0",
                    borderRight: "1px solid #e0e0e0",
                    fontSize: "13px",
                    py: 1,
                  },
                }}
              >
                {/* NAME */}
                <TableCell>{p.patientName}</TableCell>

                {/* AGE */}
                <TableCell>
                  {p.age} / {p.gender}
                </TableCell>

                {/* SEVERITY */}
                <TableCell>
                  <Chip
                    label={p.severity || "NORMAL"}
                    size="small"
                    sx={{ fontSize: "11px", height: 22 }}
                    color={
                      p.severity === "CRITICAL"
                        ? "error"
                        : p.severity === "WARNING"
                        ? "warning"
                        : "default"
                    }
                  />
                </TableCell>

                {/* MESSAGE */}
                <TableCell sx={{ maxWidth: 260 }}>
                  <Typography
                    sx={{ fontSize: "13px" }}
                    noWrap
                  >
                    {p.message}
                  </Typography>
                </TableCell>

                {/* ACTION */}
                <TableCell align="center">
                   <Button
                    variant="contained"
                    onClick={() => {
                      setSelectedNotificationId(p.notificationId);
                      setOpenPopup(true);
                    }}
                    sx={{
                      backgroundColor: "#A5D6A7",
                      color: "#000",
                      textTransform: "none",
                      fontSize: "13px",
                      borderRadius: 2,
                    }}
                  >
                    Accept/Snooze
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
             </TableHead>
        </Table>
        </TableContainer>
      </MDBox>

      {/* EMPTY */}
      {patients.length === 0 && (
        <Typography textAlign="center" mt={2} color="text.secondary">
          No alerts available
        </Typography>
      )}

      {/* VIEW ALL BUTTON */}
      <Box mt={2} textAlign="right">
        <Button
          variant="contained"
           sx={{
    backgroundColor: "#90CAF9", // lighter blue
    color: "#000", // ✅ BLACK TEXT
    "&:hover": {
      backgroundColor: "#64B5F6",
    },
    textTransform: "none",
    fontSize: "13px",
    borderRadius: 2,
    px: 3,
  }}
          onClick={() => navigate("/ViewAllPatientDetails")}
        >
          View All Patients
        </Button>
      </Box>

    </CardContent>
  </Card>
</Grid>

        </Grid>
      </Box>

      <Dialog
  open={openPopup}
  onClose={() => setOpenPopup(false)}
  PaperProps={{
    sx: {
      borderRadius: 4,
      width: 340,
      p: 2,
      position: "relative",
    },
  }}
>
  {/* ❌ Cancel Icon */}
  <IconButton
    onClick={() => setOpenPopup(false)}
    sx={{
      position: "absolute",
      top: 8,
      right: 8,
      color: "#777",
    }}
  >
    <CloseIcon fontSize="small" />
  </IconButton>

  {/* CONTENT */}
  <DialogContent sx={{ textAlign: "center", py: 2 }}>
    <Typography
     sx={{
        fontSize: "15px",
        fontWeight: 600,
        color: "#1A237E",
        mb: 1,
      }}
    >
      Patient Alert
    </Typography>

    <Typography sx={{ fontSize: "13px", color: "#555" }}>
      "Accept this alert or snooze it to be notified again in 5 minutes."
    </Typography>
  </DialogContent>

  {/* ACTION BUTTONS */}
  <DialogActions
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 1,
      px: 2,
      pb: 2,
    }}
  >
    {/* 🔵 ACCEPT */}
    <Button
      onClick={handleAcceptAlert}
      variant="contained"
      fullWidth
      sx={{
        backgroundColor: "#1A237E",
        textTransform: "none",
        fontSize: "13px",
        borderRadius: 3,
        py: 1,
        "&:hover": {
          backgroundColor: "#0D1B5E",
        },
      }}
    >
      Accept
    </Button>

    {/* 🟡 SNOOZE */}
    <Button
      onClick={handleSnooze}
      variant="outlined"
      fullWidth
      sx={{
        textTransform: "none",
        fontSize: "13px",
        borderRadius: 3,
        borderColor: "#f4b400",
        color: "#f4b400",
        "&:hover": {
          backgroundColor: "#fff8e1",
          borderColor: "#f4b400",
        },
      }}
    >
      Snooze
    </Button>
  </DialogActions>
</Dialog>
<Dialog
  open={confirmOpen}
  onClose={() => setConfirmOpen(false)}
  PaperProps={{
    sx: {
      borderRadius: 4,
      width: 380,
      p: 1,
    },
  }}
>
  {/* TITLE */}
  <DialogTitle
    sx={{
      textAlign: "center",
      fontWeight: 700,
      fontSize: "18px",
      color: "#1A237E",
      pb: 1,
    }}
  >
    {pendingToggle ? "Start Duty Shift" : "End Duty Shift"}
  </DialogTitle>

  {/* CONTENT */}
  <DialogContent sx={{ textAlign: "center", py: 2 }}>
    <Typography
      sx={{
        fontSize: "14px",
        color: "#555",
        lineHeight: 1.8,
      }}
    >
      {pendingToggle ? (
        <>
          You are about to begin your on-call duty shift.
          <br />
          Your shift timer will start immediately after confirmation.
          <br />
          Please confirm to continue.
        </>
      ) : (
        <>
          You are about to end your current duty shift.
          <br />
          Once confirmed, your active shift session will be closed.
          <br />
          Starting duty again will initiate a new shift session.
        </>
      )}
    </Typography>
  </DialogContent>

  {/* BUTTONS */}
  <DialogActions
    sx={{
      display: "flex",
      justifyContent: "center",
      gap: 2,
      pb: 2,
    }}
  >
    {/* CANCEL */}
    <Button
      onClick={() => setConfirmOpen(false)}
       variant="contained"
      sx={{
        backgroundColor: "#1A237E",
         color: "#fff",
        textTransform: "none",
        borderRadius: 3,
        px: 3,
        "&:hover": {
          backgroundColor: "#0D1B5E",
           color: "#fff",
        },
      }}
    >
      Cancel
    </Button>

    {/* CONFIRM */}
    <Button
      onClick={handleConfirm}
      variant="contained"
      sx={{
        backgroundColor: "#1A237E",
         color: "#fff",
        textTransform: "none",
        borderRadius: 3,
        px: 3,
        "&:hover": {
          backgroundColor: "#0D1B5E",
           color: "#fff",
        },
      }}
    >
      Confirm
    </Button>
  </DialogActions>
</Dialog>
    </DashboardLayout>
  );
}

export default DutyDoctorDashboard;